/* eslint-disable */
require('./tg')
